import React from "react";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import "./ImagePreview.scss";
import { getFileInfo } from "../../../utils/helper";
import commonImages from "../../../assets";

const ImagePreview = ({ files, imageUrl = "", deleteImageURL, isLoader }) => {
  const imageUrlArray = imageUrl?.length > 0 ? imageUrl.split("|") : [];
  const uniqueImageUrls = [...new Set(imageUrlArray)];

  return (
    <div className="overideImage">
      <div className="thumbContainer">
        {uniqueImageUrls.map((url, index) => {
          const fileInfo = getFileInfo(url);
          return (
            <div className="imgBox" key={url + index}>
              <div
                className="removeIcon"
                onClick={() => deleteImageURL(url, index)}
              >
                X
              </div>
              <img
                src={
                  fileInfo?.fileExtension === "tif"
                    ? commonImages?.noimage
                    : url
                }
                alt="No Files"
                className="img"
              />
            </div>
          );
        })}
        {isLoader && (
          <Stack className="loaderDropBox" spacing={2} direction="row">
            <CircularProgress color="success" />
          </Stack>
        )}
      </div>
    </div>
  );
};

export default ImagePreview;
